declare const window: any

export const managementApi = window?.env?.managementApiHost + window?.env?.managementApiPath
export const printingApi = window?.env?.managementApiHost + window?.env?.printingApiPath
export const requestAccessJiraUrl =
    'https://plantandfood.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/-l129dr/b/20/e73395c53c3b10fde2303f4bf74ffbf6/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs.js?locale=en-US&collectorId=7b851502'
